import { operations, paths } from "./generated-types";
import createClient from "openapi-fetch";
import {
  requestIdMiddleware,
  sessionTokenMiddleware,
} from "@wiesinghilker/extension-lib-frontend";

if (typeof import.meta.env.VITE_APP_API_BASE_URI != "string") {
  throw new Error("VITE_APP_API_BASE_URI is not a string");
}

const client = createClient<paths>({
  baseUrl: import.meta.env.VITE_APP_API_BASE_URI,
  credentials: "include",
});

client.use(sessionTokenMiddleware);
client.use(requestIdMiddleware);

export const listDirectoryProtections = (
  params: operations["directoryprotection.list"]["parameters"],
) => {
  return client.GET("/projects/{projectId}/directoryprotections", {
    params,
    signal: AbortSignal.timeout(2000),
  });
};

export const listAppInstallations = (
  params: operations["appinstallation.list"]["parameters"],
) => {
  return client.GET("/projects/{projectId}/appinstallations", {
    params,
    signal: AbortSignal.timeout(2000),
  });
};

export const declareDirectoryProtection = (
  body: operations["directoryprotection.declare"]["requestBody"]["content"]["application/json"],
  params: operations["directoryprotection.declare"]["parameters"],
) => {
  return client.POST("/projects/{projectId}/directoryprotections", {
    body,
    params,
    signal: AbortSignal.timeout(10000),
  });
};

export const deleteDirectoryProtection = (
  body: operations["directoryprotection.delete"]["requestBody"]["content"]["application/json"],
  params: operations["directoryprotection.delete"]["parameters"],
) => {
  return client.DELETE("/projects/{projectId}/directoryprotections", {
    body,
    params,
    signal: AbortSignal.timeout(4000),
  });
};

export const listUsers = (params: operations["user.list"]["parameters"]) => {
  return client.GET("/projects/{projectId}/users", {
    params,
    signal: AbortSignal.timeout(2000),
  });
};

export const createUser = (
  body: operations["user.create"]["requestBody"]["content"]["application/json"],
  params: operations["user.create"]["parameters"],
) => {
  return client.POST("/projects/{projectId}/users", {
    body,
    params,
    signal: AbortSignal.timeout(4000),
  });
};

export const changeUserPassword = (
  body: operations["user.change-password"]["requestBody"]["content"]["application/json"],
  params: operations["user.change-password"]["parameters"],
) => {
  return client.POST("/projects/{projectId}/users/{username}/password", {
    body,
    params,
    signal: AbortSignal.timeout(4000),
  });
};

export const deleteUser = (params: operations["user.delete"]["parameters"]) => {
  return client.DELETE("/projects/{projectId}/users/{username}", {
    params,
    signal: AbortSignal.timeout(4000),
  });
};
